import { CLASSNAME } from '~/assistant/utils/constants';
import { bem } from '~/common/classname';
import './styles.scss';

type Props = {
  target: HTMLElement;
  onClick?: () => void;
  [key: string]: any;
};

class Chat {
  props: Props;

  constructor(props: Props) {
    this.props = { ...props };
    this.render();
  }

  template() {
    const { data, botName, botImage, logoImage } = this.props;
    const classPrefix = bem([CLASSNAME, 'chat']);

    return /*html*/ `
      <ol class="${classPrefix} ${
      !!logoImage ? bem([classPrefix, 'thumb-space'], true) : ''
    }">
        <li class="${bem([classPrefix, 'question'])}">
          <div>${data?.question}</div>
        </li>
        <li class="${bem([classPrefix, 'answer'])}">
          <div class="${bem([classPrefix, 'answer', 'prepend'])}">
            ${
              botImage
                ? /*hmtl*/ `<img alt="" src="${botImage}" class="${bem([
                    classPrefix,
                    'answer',
                    'prepend',
                    'logo',
                  ])}" />`
                : /*html*/ `<span class="${bem([
                    classPrefix,
                    'answer',
                    'prepend',
                    'logo',
                  ])}">AI</span>`
            }
            <span>${botName}</span>
          </div>
          <div class="${bem([classPrefix, 'answer', 'content'])}">
            ${data?.desc}
          </div>
        </li>
      </ol>
    `;
  }

  render() {
    const { target } = this.props;
    target.insertAdjacentHTML('beforeend', this.template());
  }
}

export default Chat;
